import "antd/dist/antd.min.css";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import store from "store";

import App from "./App";
import "./styles/index.scss";

import Toast from "components/toast";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
        <Toast />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
